import React, { useState } from "react";
import { SocialCornerButton, SocialBox, SocialBoxWrap, SocialCorner } from "./SigninElements";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import { withRouter } from "react-router-dom";

import Overlay from "../../../components/Overlay";
import FacebookSide from "../../../images/facebook-side.png";
import TwitterSide from "../../../images/Twitter.png";
import InstaSide from "../../../images/InstaSide.png";
import linkedinSide from "../../../images/linkedinSide.png";
import TiktokSide from "../../../images/tiktok 1.png"

const SignIn = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <SocialCorner>
        <SocialCornerButton>
          <SocialBoxWrap>
            <a href="https://www.facebook.com/profile.php?id=61561587276058&mibextid=wwXIfr&mibextid=wwXIfr"  target="_blank">
            <SocialBox src={FacebookSide} />
            </a>
           
          </SocialBoxWrap>
          <SocialBoxWrap>
            <a href="https://www.instagram.com/menzill.com1?igsh=YWt1cGllcTBlNWJ2&utm_source=qr"  target="_blank">
            <SocialBox src={InstaSide} />
            </a>
           
          </SocialBoxWrap>
          <SocialBoxWrap>
            <a href="https://www.tiktok.com/@menzill.com1?_t=ZS-8uRET7YRA5A&_r=1" target="_blank">
              <SocialBox src={TiktokSide} />
            </a>
          </SocialBoxWrap>
          <SocialBoxWrap>
            <a href="https://x.com/menzillc?s=11" target="_blank">
            <SocialBox src={TwitterSide} />
            </a>
            
          </SocialBoxWrap>
          <SocialBoxWrap>
            <a href="https://www.linkedin.com/in/menzill-com-llc-4617b824b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank">
            <SocialBox src={linkedinSide} />
            </a>
           
          </SocialBoxWrap>
        </SocialCornerButton>
      </SocialCorner>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignIn));
